import SubmitList from "features/submits/SubmitList";
import { useParams } from "react-router-dom";

export default function WaiverSubmits() {
  const { waiver_id } = useParams();
  return <SubmitList showHeader={false} waiver_id={waiver_id} />;
}
